export default "__VITE_ASSET__TIAEvbXf__"